'use strict';

import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import scrollStore from './scroll.store';
import loaderStore from '../navigation/loader.store';

let scrollBlocks = [],
    vh,
    vw;

let active = false;

let timer;


function _add(el, halfUpdate) {
  const obj = {
    el,
    active: false,
    activate: _addClass
  };

  if (el.tagName.toLowerCase() === 'view-slider') {
    obj.activate = () => {
      el.start();
      _addClass.bind(obj)();
    }
  }

  if (!halfUpdate) el.classList.remove('show');

  scrollBlocks.push(obj);
}

function _addClass() {
  this.el.classList.add('show');

  this.active = true;
}






function _handleResize (e) {
  let scrollData = scrollStore.getData();
  vw = e.width;
  vh = e.height;

  for (let i = 0; scrollBlocks.length > i; i++) {
    if (scrollBlocks[i].resize) scrollBlocks[i].resize();

    if (scrollBlocks[i].active) continue;

    scrollBlocks[i].top = scrollBlocks[i].el.getBoundingClientRect().top + scrollStore.getData().top;
    scrollBlocks[i].height = scrollBlocks[i].el.offsetHeight;
    scrollBlocks[i].bottom = scrollBlocks[i].top + scrollBlocks[i].height;
    scrollBlocks[i].stick = scrollBlocks[i].height * 0.5 > 150 ? 150 : scrollBlocks[i].height * 0.5;
  }

  _handleScroll(scrollData);
}

function _handleScroll(e) {
  let top = e.top;

  for (let i = 0; i < scrollBlocks.length; i++) {
    if (!scrollBlocks[i].active &&
        scrollBlocks[i].top + scrollBlocks[i].stick < top + vh &&
        scrollBlocks[i].bottom - scrollBlocks[i].stick > top) {

      scrollBlocks[i].activate();
    }
  }
}


const _load = () => dispatcher.dispatch({
  type: 'component-load',
  _module: 'scrl.view',
  data: 'scrl',
  progress: 100
})



function _handleMutate(halfUpdate) {
  // if (halfUpdate) {
  //   _load();
  //   return;
  // }
  const elements = document.querySelectorAll('.scrl');

  if (!elements.length) {
    _load();
    return;
  }

  scrollBlocks = [];

  for (let i = 0; elements.length > i; i++) {
    _add(elements[i], halfUpdate);
  }

  if (halfUpdate) {
    _handleResize(resizeStore.getData());
    return;
  }

  _load();

  if (!active) {
    loaderStore.eventEmitter.subscribe((e) => {
      if (e.type === 'load-animation-play' && e.loadAnimation === 'end') {
        clearTimeout(timer);
        timer = setTimeout(() => _handleResize(resizeStore.getData()), 50);
      }
    });
    resizeStore.eventEmitter.subscribe(_handleResize);
    scrollStore.eventEmitter.subscribe(_handleScroll);
  }

  active = true;
}


function init() {
  _handleMutate();

  dispatcher.subscribe((e) => {
    if (e.type === 'mutate') _handleMutate(e.halfUpdate);
  });
}

export default {
  init: init
}
